<template>
  <v-navigation-drawer app width="200" class="side-bar-bg">
    
    <v-layout align-center justify-space-around></v-layout>
    <div
      class="text-center team-name"
      v-if="project && project.project_name"
      v-custom-click-outside="closeDropDown"
    >
      <div class="name-short">
        {{ abbrevateName(project.project_name).toUpperCase() }}
      </div>
      <div class="team-username">
        {{ truncate(project.project_name, 9) }}
        <img
          @click="isProjectList = !isProjectList"
          v-if="user.user_type === 5"
          src="/img/dashboard/client-icons/chevron-down.svg"
        />
      </div>
      <ProjectDropDown
        v-if="isProjectList"
        :projects="projects"
        v-bind="{ closeDropDown }"
      />
    </div>
    <div class="text-center team-name" v-else>
      <div class="name-short">PN</div>
      <div class="team-username">
        Product N..
        <img src="/img/dashboard/client-icons/chevron-down.svg" />
      </div>
    </div>
    <div class="sb-divider"></div>
    <div id="tab-section" class="wrap_tab">
      <div class="single-tab" v-for="(tab, index) in tabs" :key="tab.icon">
        <div
          v-if="project && !project.share_roadmap && tab.name == 'Roadmap'"
          @click.capture="goToRoadmap"
        >
          <router-link
            exact
            :key="index"
            :to="{ name: tab.route_name }"
            tag="div"
            class="sb-tab-menu c-pointer"
            active-class="selected-tab"
            style="opacity: 0.3"
          >
            <div class="tab-cover">
              <span class="opc"><img :src="tab.icon" /></span>
              <span class="tab-name">{{ tab.name }}</span>
            </div>
          </router-link>
        </div>
        <router-link
          v-else
          exact
          :key="index"
          :to="{ name: tab.route_name }"
          tag="div"
          class="sb-tab-menu c-pointer"
          active-class="selected-tab"
        >
          <div class="tab-cover">
            <span class="opc"><img :src="tab.icon" /></span>
            <span class="tab-name">{{ tab.name }}</span>
          </div>
        </router-link>
      </div>
      <div class="single-tab bottom-tab">
        <router-link
          exact
          :to="{ name: `referral` }"
          tag="div"
          class="sb-tab-menu c-pointer"
          active-class="selected-tab"
        >
          <div class="tab-cover menu-wrapper">
            <span class="opc">
              <img src="/img/dashboard/client-icons/referral.svg" />
            </span>
            <span class="tab-name" style="padding-top: 4px">
              Refer a friend
            </span>
          </div>
        </router-link>
        <div class="tab-cover menu-wrapper" @click="isViewProfile = true">
          <LogoutMenu
            v-if="isViewProfile"
            v-bind="{ user, truncate, closeLogoutMenu }"
          />
          <v-avatar
            v-if="user.profile_picture"
            :size="32"
            color="grey lighten-4"
            class="profile_bg"
            :style="{
              backgroundImage: `url(${
                $imageUrl + user.profile_picture || imageAvatar
              })`,
            }"
          ></v-avatar>
          <div v-else class="name-avatar">
            {{ abbrevateName(user.name).toUpperCase() }}
          </div>
          <div class="tab-name" style="margin-left: 8px; margin-top: 8px">
            {{ truncate(user.name, 15) }}
          </div>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>



<script>
import { mapState, mapActions } from "vuex";
import shortName from "@/mixins/shortName";
import truncate from "@/mixins/truncate";
import LogoutMenu from "@/components/Popups/logoutMenu";
import ProjectDropDown from "../components/ProjectDropDown.vue";
export default {
  props: {
    tabs: {
      type: Array,
    },
  },
  components: {
    LogoutMenu,
    ProjectDropDown,
  },
  mixins: [shortName, truncate],
  data() {
    return {
      imageAvatar: "/img/onboarding/profile-avatar.svg",
      isViewProfile: false,
      isProjectList: false,
    };
  },

  mounted() {},

  methods: {
    goToRoadmap(e) {
      e.preventDefault();
    },
    closeLogoutMenu() {
      this.isViewProfile = false;
    },
    closeDropDown() {
      this.isProjectList = false;
    },
  },
  computed: {
    ...mapState("clientDashboard", ["clientProject", "allProjects"]),
    ...mapState("userManagement", ["currentUser"]),
    project() {
      return this.clientProject;
    },
    projects() {
      let projects = JSON.parse(JSON.stringify(this.allProjects));
      return projects.reverse();
    },
    user() {
      return this.currentUser;
    },
  },
};
</script>

<style scoped>
* {
  font-family: Moderat, sans-serif;
}
.side-bar-bg {
  background: #1b1e22;
  width: 200px;
}
.selected-tab > img {
  filter: invert(34%) sepia(55%) saturate(7080%) hue-rotate(208deg)
    brightness(95%) contrast(104%) !important;
}
.selected-tab > div > span > img {
  filter: invert(1) brightness(100) !important;
}
.selected-tab > div > span.opc {
  opacity: 1;
}
.sb_active_tab > div > span.sb-text {
  opacity: unset;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 145%;
  color: #ffffff;
}
.opc {
  opacity: 0.7;
  margin-right: 12px;
}
.sb-text {
  color: #979da5;
}
.wrap_tab {
  position: relative;
  height: calc(100vh - 88px);
}
.bottom_tab {
  position: absolute;
  bottom: 109px;
  left: 0px;
  right: 0px;
}

.sb-navigation-drawer {
  background-color: #212121;
  width: 200px;
  margin: 0;
  padding: 0;
}

.sb-divider {
  border-top: 1px solid #383e47;
  margin: 5px 0px;
}
.sb-text {
  font-style: Medium;
  font-size: 12px;
  line-height: 20px;
  margin-top: 4px;
  margin-bottom: 5px;
  text-align: center;
  color: #cdcdcd;
  font-weight: 500;
  /* opacity: 0.65; */
}
.sb-text-active {
  color: #212121;
  font-weight: 700;
  opacity: 1;
}

/* New Styles */
.team-name {
  margin: 16px 22px;
  display: flex;
  position: relative;
}
.name-short {
  background: #ffffff;
  border-radius: 4px;
  padding: 5px 6px;
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  color: #1b1e22;
}
.team-username {
  font-size: 16px;
  line-height: 130%;
  text-align: center;
  color: #ffffff;
  margin-left: 8px;
  margin-top: 5px;
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
}
.team-username img {
  cursor: pointer;
}
.wrap_tab {
  margin-top: 24px;
}
.single-tab {
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 8px;
}
.tab-cover {
  padding: 12px;
  text-align: initial;
}
.selected-tab {
  background: #131416;
  border-radius: 4px;
}
.selected-tab span {
  font-weight: normal;
  font-size: 14px;
  line-height: 130%;
  color: #ffffff;
}
.tab-name {
  font-weight: normal;
  color: #979da5;
  font-size: 14px;
  line-height: 130%;
}
.c-pointer {
  cursor: pointer;
}
.bottom-tab {
  position: absolute;
  bottom: 54px;
  left: 0px;
  right: 0px;
}
.menu-wrapper {
  position: relative;
  display: flex;
  cursor: pointer;
}
.name-avatar {
  width: 32px;
  height: 32px;
  background: #54bdd4;
  border-radius: 50%;
  font-weight: normal;
  font-size: 10px;
  line-height: 12px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>




